import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle, CheckCircle2 } from "lucide-react";
import { company, services } from "../mock";
import { Reveal, PageHero } from "../components/Shared";
import useSEO from "../hooks/useSEO";

const Hizmetler = () => {
  useSEO({
    title: "Hizmetlerimiz - Personel, Öğrenci, VIP Taşımacılığı ve Araç Kiralama",
    description:
      "Personel taşımacılığı, öğrenci taşımacılığı, VIP taşımacılık ve araç kiralama hizmetleri. Kocaeli'de 42 yılı aşkın tecrübeyle profesyonel ulaşım çözümleri.",
  });

  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        setTimeout(() => {
          const y = el.getBoundingClientRect().top + window.scrollY - 110;
          window.scrollTo({ top: y, behavior: "smooth" });
        }, 150);
      }
    }
  }, [hash]);

  return (
    <div>
      <PageHero
        title="Hizmetlerimiz"
        subtitle="Personel ve öğrenci taşımacılığından VIP taşımacılığa ve araç kiralamaya; 42 yılı aşkın tecrübemizle ihtiyacınıza uygun profesyonel ulaşım çözümleri sunuyoruz."
      />

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-24">
          {services.map((s, i) => (
            <div
              key={s.id}
              id={s.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center ${
                i % 2 === 1 ? "lg:[direction:rtl]" : ""
              }`}
            >
              <Reveal
                direction={i % 2 === 1 ? "right" : "left"}
                className="lg:[direction:ltr]"
              >
                <div className="relative rounded-2xl overflow-hidden shadow-xl group">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-[340px] sm:h-[400px] object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#081f3b]/50 to-transparent" />
                  <span className="absolute top-5 left-5 bg-white/90 backdrop-blur-sm text-[#0d2b4f] text-xs font-bold px-4 py-2 rounded-full">
                    {`0${i + 1}`} / {`0${services.length}`}
                  </span>
                </div>
              </Reveal>

              <Reveal
                direction={i % 2 === 1 ? "left" : "right"}
                className="lg:[direction:ltr]"
              >
                <p className="section-label text-[#1e9cd7] text-xs font-bold uppercase mb-3">
                  Nikomedya Turizm
                </p>
                <h2 className="text-2xl sm:text-3xl font-bold text-[#0d2b4f] leading-snug tracking-tight">
                  {s.title}
                </h2>
                <p className="mt-5 text-[#5b6b7d] leading-relaxed text-[15px]">
                  {s.description}
                </p>
                <ul className="mt-7 space-y-3.5">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-start gap-3">
                      <CheckCircle2
                        size={20}
                        className="text-[#1e9cd7] shrink-0 mt-0.5"
                      />
                      <span className="text-[15px] text-[#1a2433]">{f}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href={`https://wa.me/${company.whatsappNumber}?text=${encodeURIComponent(
                    `Merhaba, ${s.title} hizmetiniz hakkında teklif almak istiyorum.`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-whatsapp mt-9 inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold text-sm"
                >
                  <MessageCircle size={18} />
                  Bu Hizmet İçin Teklif Al
                </a>
              </Reveal>
            </div>
          ))}
        </div>
      </section>

      {/* CTA strip */}
      <section className="pb-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="bg-[#f5f8fb] border border-slate-100 rounded-3xl px-8 sm:px-14 py-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
              <div>
                <h3 className="text-xl sm:text-2xl font-bold text-[#0d2b4f] tracking-tight">
                  Size özel çözüm mü gerekiyor?
                </h3>
                <p className="mt-2 text-[#5b6b7d]">
                  İhtiyacınıza göre planlanmış taşımacılık çözümleri için
                  bize ulaşın: {company.phone}
                </p>
              </div>
              <a
                href={company.whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-whatsapp inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold text-sm shrink-0"
              >
                <MessageCircle size={18} />
                WhatsApp'tan Yazın
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Hizmetler;
